"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var SiteUrlsContext_1 = require("./urls/SiteUrlsContext");
/** This matches the HiddenUserStyle in VizPortalClient */
exports.UserPlaceholderStyle = {
    color: '#BFBFBF',
    fontWeight: 'inherit'
};
function DefaultNoneUserElement() {
    return React.createElement("span", { style: exports.UserPlaceholderStyle }, Localize_1.Messages.None());
}
exports.DefaultNoneUserElement = DefaultNoneUserElement;
function DefaultHiddenUserElement() {
    return React.createElement("span", { style: exports.UserPlaceholderStyle }, Localize_1.Messages.HiddenUser());
}
exports.DefaultHiddenUserElement = DefaultHiddenUserElement;
function UserNameText(props) {
    return React.createElement("span", null, props.name);
}
exports.UserNameText = UserNameText;
function isUserInfoVisible(user) {
    // Some fields may still possibly be empty string, which is still "visible"
    return user.domain !== null && user.name !== null && user.username !== null;
}
exports.isUserInfoVisible = isUserInfoVisible;
function getUserNameForDisplay(user) {
    return user.name || user.username;
}
exports.getUserNameForDisplay = getUserNameForDisplay;
function getUserUrlForDisplay(urls, user) {
    return urls.userUrl(user.username, user.domain);
}
exports.getUserUrlForDisplay = getUserUrlForDisplay;
function getUserPathForDisplay(urls, user) {
    return urls.userPath(user.username, user.domain);
}
exports.getUserPathForDisplay = getUserPathForDisplay;
function UserTextDisplayComponent(props) {
    if (!props.user) {
        return props.noneUserElement || React.createElement(DefaultNoneUserElement, null);
    }
    else if (!isUserInfoVisible(props.user)) {
        return props.hiddenUserElement || React.createElement(DefaultHiddenUserElement, null);
    }
    else {
        var name_1 = getUserNameForDisplay(props.user);
        return React.createElement(UserNameText, { name: name_1 });
    }
}
exports.UserTextDisplayComponent = UserTextDisplayComponent;
function UserLinkDisplayComponent(props) {
    var urls = React.useContext(SiteUrlsContext_1.SiteUrlsContext);
    if (!props.user) {
        return props.noneUserElement || React.createElement(DefaultNoneUserElement, null);
    }
    else if (!isUserInfoVisible(props.user)) {
        return props.hiddenUserElement || React.createElement(DefaultHiddenUserElement, null);
    }
    else {
        var name_2 = getUserNameForDisplay(props.user);
        var url = getUserUrlForDisplay(urls, props.user);
        var path = getUserPathForDisplay(urls, props.user);
        return React.createElement(props.linkComponent, { name: name_2, url: url, pathname: path });
    }
}
exports.UserLinkDisplayComponent = UserLinkDisplayComponent;
//# sourceMappingURL=UserDisplayComponent.js.map